// Modules
import React, { useState } from 'react'
import { Body, Button, Flex, Heading, Spacing } from '@dasa-health/alma-react'
import { InfoRound } from '@dasa-health/alma-icons'
// Application
import Qr from 'assets/qrcode.svg'
// Components
import { QrcodeImage, TypographContainer } from './styles'
import { Modal } from 'redesign/components/molecules/Modal'

export const SelfServiceModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)

    const toggleModal = () => setIsModalOpen(value => !value)

    return (
        <>
            <Button leadingIcon={<InfoRound />} onClick={toggleModal} size="sm" type="button" variant="tertiary">
                Não consigo acessar
            </Button>
            <Modal isOpen={isModalOpen} onRequestClose={toggleModal}>
                <TypographContainer>
                    <Heading variant="md">Não consigo acessar</Heading>
                    <Spacing size="nano" />
                    <Body fontStyle="normal" marginTop={8} variant="lg">
                        Está com problemas com sua senha ou gostaria de fazer um cadastro no Nav Dasa?
                    </Body>
                    <Body fontStyle="normal" marginTop={8} variant="lg">
                        Aponte a câmera do seu celular para o QR Code abaixo e siga as instruções ou acesse nav.com.br/entrar
                    </Body>
                    <Flex alignItems="center" justifyContent="center" margin="16px 0 36px">
                        <QrcodeImage src={Qr} />
                    </Flex>

                    <Button color="#0037FF !important" onClick={toggleModal} variant="tertiary">
                        Fechar
                    </Button>
                </TypographContainer>
            </Modal>
        </>
    )
}
